import { Box, Button, Typography } from '@mui/material';
import ClassIcon from '@mui/icons-material/Class';

export const CategoryGridItem = ({ category, onClick }) => {
  const { label, color, icon, projectsCount, VirtualIcon } = category;
  const url = icon?.temporaryUrl;

  return (
    <Button
      onClick={() => onClick(category)}
      variant="contained"
      color="secondary"
      sx={{
        transition: 'scale 0.3s ease',
        padding: '5px',
        border: `1px solid ${color}80`,
        position: 'relative',
      }}
      className="cursor-pointer w-full flex flex-col backdrop-blur-lg items-center rounded-lg"
    >
      {projectsCount != null && (
        <Box
          sx={{
            position: 'absolute',
            top: 6,
            right: 6,
            minWidth: '24px',
            height: '24px',
            padding: '0 8px',
            borderRadius: '12px',
            bgcolor: color + '40',
            border: `1px solid ${color}80`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px',
            fontWeight: 600,
          }}
        >
          {projectsCount}
        </Box>
      )}
      <Box
        className="h-32 w-32 rounded-full flex items-center justify-center"
        sx={{ bgcolor: color + '30' }}
      >
        {url ? (
          <img alt="" src={url} className="h-20 w-20 object-contain" />
        ) : VirtualIcon ? (
          <VirtualIcon sx={{ fontSize: '64px', color }} />
        ) : (
          <ClassIcon sx={{ fontSize: '64px', color }} />
        )}
      </Box>
      <Typography
        variant="h5"
        className="pt-4 break-words text-center"
        sx={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'normal',
        }}
      >
        <b>{label}</b>
      </Typography>
    </Button>
  );
};
